import React from 'react'

import Image from '../../Image';

import SliderInSteps from '../SliderInSteps/SliderInSteps'

export default function Stepone() {
   return (
      <div className='st_eac'>
         <div className='steps_t_1'>Fundamentals</div>
         <div className='st_t_im_c'>
            <Image
               src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/clock.svg'
               alt='clock'
               loading='lazy'
               height={18}
               width={18}
            />
            <div className='dur_txt'>
               Duration : <span className='st_d_m'>2 Months</span>
            </div>
         </div>
         <div className='st_t_im_c'>
            <Image
               src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/laptop-icon.svg'
               alt='laptop-icon'
               loading='lazy'
               height={18}
               width={18}
            />
            <div className='st_inf_txt'>
               3 Hours Classes and 3 Hours Labs per day
            </div>
         </div>
         <div className='st_t_im_c'>
            <Image
               src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/book.svg'
               alt='book'
               loading='lazy'
               height={18}
               width={18}
            />
            <div className='st_inf_txt'>Courses Include</div>
         </div>
         <div className='st_ln_co'>
            <div className='st_eac_l'>
               <Image
                  className='st_eac_l_im'
                  src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/html.png'
                  alt='html'
                  loading='lazy'
                  height={64}
                  width={64}
               />
               <div className='st_ln_tx'>HTML</div>
            </div>
            <div className='st_eac_l'>
               <Image
                  className='st_eac_l_im'
                  src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/css.png'
                  alt='css'
                  loading='lazy'
                  height={64}
                  width={64}
               />
               <div className='st_ln_tx'>CSS</div>
            </div>
            <div className='st_eac_l'>
               <Image
                  className='st_eac_l_im'
                  src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/python.png'
                  alt='python'
                  loading='lazy'
                  height={57}
                  width={56}
               />
               <div className='st_ln_tx'>Python</div>
            </div>
            <div className='st_eac_l'>
               <Image
                  className='st_eac_l_im'
                  src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/sql.png'
                  alt='sql'
                  loading='lazy'
                  height={57}
                  width={56}
               />
               <div className='st_ln_tx'>SQL</div>
            </div>
         </div>
         <div className='st_t_im_c'>
            <Image
               src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/clipboard-icon.svg'
               alt='clipboard-icon'
               loading='lazy'
               height={18}
               width={18}
            />
            <div className='st_inf_txt'>Fundamentals Exam</div>
         </div>

         <div className='st_sl_1con'>
            <SliderInSteps>
               <div className='keen-slider__slide '>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/food-munch-project-status.png'
                     alt='food-munch-project-status'
                     loading='lazy'
                     height={642}
                     width={860}
                     className='st_1_s_im'
                  />
               </div>
               <div className='keen-slider__slide '>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/website-chat-project-status.png'
                     alt='website-chat-project-status'
                     loading='lazy'
                     height={595}
                     width={846}
                     className='st_1_s_im'
                  />
               </div>
               <div className='keen-slider__slide '>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/slider-fundamenatils-image.png'
                     alt='slider-fundamantals-image'
                     loading='lazy'
                     height={758}
                     width={798}
                     className='st_1_s_im'
                  />
               </div>
            </SliderInSteps>
         </div>
      </div>
   )
}
